import type { GetDesignerNodeDataById, GetNodeSlotId } from "@skilitics/nautilus-core-designer-data";
import { resolveActiveNodesDataCreate } from "@skilitics/nautilus-core-designer-data";

import type { BuildDesignerNode } from "../../state/buildDesignerNode.ts";
import type { DesignerNode, GetManifestByTypeId } from "../../types/index.ts";

interface Options {
  getManifest: GetManifestByTypeId;
  buildDesignerNode: BuildDesignerNode;
  getSlotId: GetNodeSlotId;
  getNodeById: GetDesignerNodeDataById;
}

export const resolveActiveNodesCreate = ({
  getManifest,
  buildDesignerNode,
  getSlotId,
  getNodeById,
}: Options): ResolveActiveNodes => {
  const resolveActiveNodesData = resolveActiveNodesDataCreate(
    (typeId: string) => getManifest(typeId).terminus,
    getSlotId,
    getNodeById,
  );

  return (nodeId) => resolveActiveNodesData(nodeId).map(buildDesignerNode);
};

export type ResolveActiveNodes = (id: number) => DesignerNode[];
